import { useCallback } from 'react';
import {
	useGlobalState,
	useGlobalDispatch,
} from '../stateProviders/GlobalStateProvider';

export const useCanvasFullscreenToggle = () => {
	const globalState = useGlobalState();
	const globalDispatch = useGlobalDispatch();

	const toggleCanvasFullscreen = useCallback(() => {
		globalDispatch({
			canvasFullscreen: !globalState.canvasFullscreen,
			sidebarCollapsed: !globalState.canvasFullscreen ? true : false,
		});
	}, [globalState.canvasFullscreen, globalDispatch]);

	const minimiseCanvas = useCallback(() => {
		globalDispatch({
			canvasFullscreen: false,
		});
	}, [globalDispatch]);

	return {
		isCanvasFullscreen: globalState.canvasFullscreen,
		toggleCanvasFullscreen,
		minimiseCanvas,
	};
};
